import { Avatar as AntAvatar, AvatarProps as AntdAvatarProps } from 'antd';
import { colors } from 'theme/colors';

import { cn } from 'utils/cn';

export interface AvatarProps extends AntdAvatarProps {
  backgroundColor?: string;
  color?: string;
}

export function Avatar({
  backgroundColor,
  color,
  style,
  className,
  size = 'small',
  ...props
}: AvatarProps) {
  return (
    <AntAvatar
      {...props}
      style={{
        backgroundColor,
        color: color || colors.colorText,
        ...style,
      }}
      size={size}
      className={cn(className, 'font-normal')}
    />
  );
}
